"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2019 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Webhooks = /*#__PURE__*/function () {
  function Webhooks(registry) {
    (0, _classCallCheck2["default"])(this, Webhooks);
    this._api = registry;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Webhooks, [{
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(appId, selector) {
        var fieldMask, result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context.next = 3;
                return this._api.List({
                  routeParams: {
                    'application_ids.application_id': appId
                  }
                }, fieldMask);

              case 3:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadListResponse('webhooks', result));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appId, webhook) {
        var mask,
            result,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                mask = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : _marshaler["default"].fieldMaskFromPatch(webhook, this._api.SetAllowedFieldMaskPaths);
                _context2.next = 3;
                return this._api.Set({
                  routeParams: {
                    'webhook.ids.application_ids.application_id': appId
                  }
                }, {
                  webhook: webhook,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function create(_x3, _x4) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(appId, webhookId, selector) {
        var fieldMask, result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context3.next = 3;
                return this._api.Get({
                  routeParams: {
                    'ids.application_ids.application_id': appId,
                    'ids.webhook_id': webhookId
                  }
                }, fieldMask);

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getById(_x5, _x6, _x7) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(appId, webhookId, patch) {
        var mask,
            result,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                mask = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : _marshaler["default"].fieldMaskFromPatch(patch, this._api.SetAllowedFieldMaskPaths);
                _context4.next = 3;
                return this._api.Set({
                  routeParams: {
                    'webhook.ids.application_ids.application_id': appId,
                    'webhook.ids.webhook_id': webhookId
                  }
                }, {
                  webhook: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateById(_x8, _x9, _x10) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }()
  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(appId, webhookId) {
        var result;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.Delete({
                  routeParams: {
                    'application_ids.application_id': appId,
                    webhook_id: webhookId
                  }
                });

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteById(_x11, _x12) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "getFormats",
    value: function () {
      var _getFormats = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var result;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.GetFormats();

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getFormats() {
        return _getFormats.apply(this, arguments);
      }

      return getFormats;
    }()
  }, {
    key: "listTemplates",
    value: function () {
      var _listTemplates = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(selector) {
        var fieldMask, result;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context7.next = 3;
                return this._api.ListTemplates(undefined, fieldMask);

              case 3:
                result = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadListResponse('templates', result));

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function listTemplates(_x13) {
        return _listTemplates.apply(this, arguments);
      }

      return listTemplates;
    }()
  }, {
    key: "getTemplate",
    value: function () {
      var _getTemplate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(templateId, selector) {
        var fieldMask, result;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context8.next = 3;
                return this._api.GetTemplate({
                  routeParams: {
                    'ids.template_id': templateId
                  }
                }, fieldMask);

              case 3:
                result = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getTemplate(_x14, _x15) {
        return _getTemplate.apply(this, arguments);
      }

      return getTemplate;
    }()
  }]);
  return Webhooks;
}();

var _default = Webhooks;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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